import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/new-logo-footer.svg")